import React from 'react';

export function NotFound() {
  return (
    <div className='products'>
      <h1>NotFound</h1>
    </div>
  );
}